// extracted by mini-css-extract-plugin
export default {"wrapper":"BlockWrapper_wrapper__-W7GO","editable":"BlockWrapper_editable__7Zn6F","selected":"BlockWrapper_selected__6hhO0","typeLabel":"BlockWrapper_typeLabel__7ALSZ"};